import React from 'react';
import { connect } from 'react-redux';

import { DangerouslyHtml } from 'apps/auth/components/common/DangerouslyHtml/DangerouslyHtml';
import BaseLayout from 'apps/auth/components/common/Layout/BaseLayout';
import { InfoPage } from 'apps/auth/components/common/Layout/InfoPage/InfoPage';
import BasePage from 'apps/auth/components/utils/BasePage';
import { AUTH_SEND_MAIN_LINK } from 'apps/auth/constants/UrlConstants';

const MastercardPromoIntro = (props) => {
    const getText = (text) => {
        return <DangerouslyHtml dangerouslyHtml={text} />;
    };

    let rowButtonProps = {};
    if (props.showTwoButton) {
        rowButtonProps = {
            buttonRowType: 'link',
            buttonRowCaption: props.learnMoreButton,
            buttonRowHref: '/docs/mastercard_hero_promo_action_ru.pdf',
            buttonRowTarget: '_blank',
        };
    }
    const iconNames = {
        'bg-icon-80_confetti_purple': 'confetti-thin',
        'bg-icon-80_card-mastercard_purple': 'card-mastercard-thin',
    };
    return (
        <BaseLayout showChat={false}>
            <InfoPage
                {...rowButtonProps}
                iconName={iconNames[props.iconPromo]}
                iconColor="primary"
                headerText={getText(props.profileMastercardPromoTitle)}
                secondaryText={getText(props.profileMastercardPromoInfo)}
                primaryButtonCaption={props.gotItButton}
                primaryButtonType="link"
                primaryButtonLink={AUTH_SEND_MAIN_LINK}
            />
        </BaseLayout>
    );
};

const mapStateToProps = (state) => {
    return {
        profileMastercardPromoTitle: state.messages.pageMessages.profileMastercardPromoTitle,
        profileMastercardPromoInfo: state.messages.pageMessages.profileMastercardPromoInfo,
        profilePromoButton: state.messages.pageMessages.profilePromoButton,
        learnMoreButton: state.messages.pageMessages.learnMoreButton,
        gotItButton: state.messages.pageMessages.gotItButton,
        iconPromo: state.extra.iconPromo,
        showTwoButton: state.extra.showTwoButton,
        mastercardPromo: state.extra.mastercardPromo,
    };
};

export default connect(mapStateToProps)(BasePage(MastercardPromoIntro));
